import { render, staticRenderFns } from "./jyReleaseGoodsDialog.vue?vue&type=template&id=5d8a278a&scoped=true&"
import script from "./jyReleaseGoodsDialog.vue?vue&type=script&lang=js&"
export * from "./jyReleaseGoodsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a278a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d8a278a')) {
      api.createRecord('5d8a278a', component.options)
    } else {
      api.reload('5d8a278a', component.options)
    }
    module.hot.accept("./jyReleaseGoodsDialog.vue?vue&type=template&id=5d8a278a&scoped=true&", function () {
      api.rerender('5d8a278a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/jyReleaseGoodsDialog.vue"
export default component.exports